import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES,
    CHAT_UNREAD_COUNT,
    CHAT_UNREAD_RESET,
} from "../store/types";

const INITIAL_STATE = {
    messages: [],
    loading: false,
    error: {
        flag: false,
        msg: null
    },
    unreadCount: 0,
    unreadBookingId: null,
}

export const chatreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_MESSAGES:
            return {
                ...state,
                loading: true
            };
        case FETCH_MESSAGES_SUCCESS:
            return {
                ...state,
                messages: action.payload,
                loading: false
            };
        case FETCH_MESSAGES_FAILED:
            return {
                ...state,
                messages:null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case SEND_MESSAGE:
            return state;
        case STOP_FETCH_MESSAGES:
            return {
                ...INITIAL_STATE,
                unreadCount: state.unreadCount,
                unreadBookingId: state.unreadBookingId,
            };
        case CHAT_UNREAD_COUNT:
            return {
                ...state,
                unreadCount: action.payload.count,
                unreadBookingId: action.payload.bookingId,
            };
        case CHAT_UNREAD_RESET:
            if (state.unreadBookingId === action.payload) {
                return {
                    ...state,
                    unreadCount: 0,
                    unreadBookingId: null,
                };
            }
            return state;
        default:
            return state;
    }
};
